<template>
    <div class="card-list" v-if="orderList.length">
        <div class="card-one" v-for="(item,index) in orderList" 
        :key="index" 
        :class="activeIndex == index ? 'card-active' : !item.isBuy ? 'no-buy' : ''"
        @click=" select(item,index)"
        >
            <div class='card-one-l'>
                <h3>{{item.Title}}</h3>
                <p>￥ <span>{{item.Price}}</span></p>
            </div>
            <div class='card-one-c'>
                <div class="dot dot_top"></div>
                <div class="dot dot_bot"></div>
            </div>
            <div class='card-one-r'>
                <p>起购数量：{{item.Number}}</p>
            </div>
        </div>

        <van-popup
            v-model="showList"
            round
            position="bottom"
            style="padding-top: 4px;"
            >
            <div class="popup-model">
                <div class="popup-cell">
                    <span>数量</span>
                    <van-stepper v-model="num" button-size="22" disable-input :min="minStep" @change="onChange"/>
                </div>
                <div class="popup-totol">
                    <span>合计：<i>￥</i></span>
                    {{TotolPrice}}
                </div>
                <div class="popup-submit" @click="next()">
                    下一步
                </div>
            </div>
        </van-popup>

    </div>
</template>
<script>
import { mapActions , mapGetters } from 'vuex';
export default {
    data(){
        return{
          activeIndex:-1,
          showList:false,
          num:0,
          orderList:[],
          TotolPrice:0,
          minStep:1,
          onePrice:0,
          title:'',
        }
    },
    computed: {
        actId(){
            return this.$route.params.id
        }
    },
    mounted(){
        this.init();
    },
    methods:{
        ...mapActions({
            actOrder:'act/actOrder',
            LinkToActReg:'linkTo/LinkToActReg',
        }),
        async init(){
           let res = await this.actOrder(this.actId);
           if(res.data){
               if(res.data.activityTickets.indexOf('[') !== -1){
                   this.orderList = JSON.parse(res.data.activityTickets);
                   this.orderList.map(c=>{
                       if(c.Price){
                           c.Price = c.Price/100;
                       }
                       c.isBuy = this.compareDate(c.StartAt,c.EndAt);
                   })
                   console.log(this.orderList,'this.orderList')
               }
           }
        },
        // 比较时间
        compareDate(statedate1, enddate1) {
            let statedate = statedate1.slice(0,10) + ' ' + statedate1.slice(11,19);
            let enddate = enddate1.slice(0,10) + ' ' + enddate1.slice(11,19);
            const stateTime = new Date(statedate.replace(/-/g, "/")).getTime();
            const Time = new Date().getTime();
            const endTime = new Date(enddate.replace(/-/g, "/")).getTime();
            if (stateTime < Time && Time < endTime) {
                return true; //进行中
            } else if (endTime < Time) {
                return false; //已结束
            } else {
                return false; //未开始
            }
        },
        select(item,index){
            if(!item.isBuy){
                this.$toast('该票种不可购买！');
            } else {
                this.$toast.clear();
                this.activeIndex = index; 
                this.showList = true;
                this.num = item.Number;
                this.onePrice = item.Price;
                this.TotolPrice = this.onePrice * this.num;
                this.minStep = item.Number;
                this.title = item.Title;
            }
        },
        onChange(e){
           this.TotolPrice = this.onePrice * e;
        },
        next(){
            let opt = {
                    actId:this.actId, // 活动的id
                    num:this.num, // 购票的数量
                    totalPrice:this.TotolPrice, // 总价
                    title:this.title,
                };
            this.$store.commit('wxPay/setOrder',opt);
            this.LinkToActReg(this.actId);
        },
    },
}
</script>
<style lang="scss" scoped>
.card{
    &-list{
        min-height: 100vh;
        width: 100%;
        background: #f2f2f2;
        padding: .3rem ;
    }
    &-one{
        width: 100%;
        height: 1.82rem;
        background-color: #fff;
        box-shadow: 0px 0px .1rem 0px 
            rgba(0, 0, 0, 0.1);
        border-radius: .1rem;
        display:flex;
        margin: .3rem 0;
        &-l{
           width: 68%;
           padding: .3rem;
           display: flex;
           flex-direction: column;
           justify-content: center;
           border-radius: .1rem 0 0 .1rem;
           h3{
                font-size: .3rem;
                font-weight: 600;
                line-height: 1.3;
                color: #333;
                margin-bottom: .2rem;
           }
           p{
                font-size: .3rem;
                color: #ff5e00;
                span{
                    font-weight: 600;
                    font-size: .36rem;
                }
           }
        }
        &-c{
           width: 0.24rem;
           position: relative;
           height: 100%;
           overflow: hidden;
           .dot.dot_top{
                border-top: none;
                top: -.12rem;
                border-radius: 0 0 100% 100%;
            }
            .dot.dot_bot{
                border-bottom: none;
                bottom: -.12rem;
                border-radius: 100% 100% 0 0;
            }
            .dot{
                width: 0.24rem;
                height: 0.24rem;
                position: absolute;
                box-shadow: inset 0px 3px 10px 0px rgba(0, 0, 0, 0.14);
                overflow: hidden;
            }
        }
        &-c::after{
            position: absolute;
            content: "";
            display: block;
            border-left: 1px dashed #e5e5e5;
            height: calc(100% - .24rem);
            left: 50%;
            top: .12rem;
            transform: translateX(-50%);
        }
        &-r{
           flex:1;
           padding: .1rem;
           display: flex;
           flex-direction: column;
           justify-content: center;
           border-radius: 0 .1rem .1rem 0;
           p{
               font-size: .26rem;
               color: #666;
           }
        }
    }
    &-one:first-child{
        margin-top: 0;
    }
    &-active{
        background-image: linear-gradient(
		rgba(24, 144, 255, 0.1), 
		rgba(24, 144, 255, 0.1)), 
        linear-gradient(
            #fff, 
            #fff);
        background-blend-mode: normal, 
            normal;
        .card-one-l{
           border: 1px solid #6ab7fe; 
           border-right: none;
        }
        .card-one-r{
           border: 1px solid #6ab7fe; 
           border-left: none;
        }
        .card-one-c::after{
           border-left: 1px dashed #1890ff;
        }
        .dot{
            border: 1px solid #6ab7fe;
        }
    }
}
.no-buy{
    box-shadow: none;
    .card-one-l{
        h3{
            color: #bfbfbf;
        }
        p{
            color: #bfbfbf;
        }
    }
    .card-one-r{
        p{
            color: #bfbfbf;
        }
    }
}
.popup-model{
    padding: .4rem .3rem;
    .popup-cell{
        display: flex;
        align-items: center;
        justify-content: space-between;
        span{
            font-size: .26rem;
            color: #333;
        }
        margin-bottom: .26rem;
    }
    .popup-totol{
        display: flex;
        align-items: center;
        font-size: .3rem;
        color: #ff5e00;
        font-weight: 600;
        span{
            font-size: .26rem;
            color: #333;
            font-weight: normal;
            i{
                font-style: normal;
                font-size: .24rem;
                color: #ff5e00;
                font-weight: normal
            }
        }
    }
    .popup-submit{
        margin-top: .3rem;
        width: 100%;
        height: .74rem;
        background-color: #1890ff;
        border-radius: .37rem;
        text-align: center;
        color: #fff;
        line-height: .74rem;
    }
}
</style>